/// <amd-module name="TFS/Admin/Views/AdminRoles/Components/AdminRolesInitializer" />
import * as React from "react";
import { connect } from "react-redux";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { IAdminRolesState } from "TFS/Admin/Views/AdminRoles/Contracts";
import { getLoading } from "TFS/Admin/Views/AdminRoles/Redux/AdminRolesSelectors";
import { AdminRolesActions } from "TFS/Admin/Views/AdminRoles/Redux/AdminRolesActions";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { Page } from "VSSUI/Page";
import { Header, TitleSize } from "VSSUI/Header";
import * as Resources from "TFS/Admin/Views/AdminRoles/Resources";

interface IAdminRolesContainerProps {
    context: IVssComponentContext;
}

interface IAdminRolesInitializerOwnProps extends IAdminRolesContainerProps {
    loading: boolean;
}

export type IAdminRolesInitializerProps = IAdminRolesInitializerOwnProps & typeof ActionsToDispatch;

interface AdminRolesInitializerState {}

export class AdminRolesInitializer extends VssComponent<IAdminRolesInitializerProps, AdminRolesInitializerState> {
    public constructor(props: IAdminRolesInitializerProps) {
        super(props);

        this.props.initView();
    }

    public render(): JSX.Element {
        return (
            <Surface background={SurfaceBackground.neutral}>
                <Page className="flex-grow flex-column">
                    <Header title={Resources.AdminRolesViewTitle} titleSize={TitleSize.Large} />
                </Page>
            </Surface>
        );
    }
}

//Update component props whenever the store's state changes
function mapStateToProps(state: IAdminRolesState, providedProps: IAdminRolesContainerProps): Partial<IAdminRolesInitializerProps> {
    return {
        ...providedProps,
        loading: getLoading(state)
    };
}

//Hook up action creators to reducer
const ActionsToDispatch = {
    initView: AdminRolesActions.initView
};

export const ConnectedAdminRolesInitializer = connect(
    mapStateToProps,
    ActionsToDispatch
)(AdminRolesInitializer);
